import React from 'react'
import { makeStyles, Tooltip, Avatar } from '@material-ui/core'
import CustomTable from '../table/CustomTable'
import { numberFromText } from '../../utils/helpers'
import { AvatarGroup } from '@material-ui/lab'
import moment from 'moment'

import StyledSVG from '../shared/StyledSVG'
import { colors } from '../../utils/constants'

import warningSVG from '../../assets/icons/chat-warning.svg'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    fontFamily: 'Montserrat, Source Sans Pro'
  },
  page_title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 8,
    '& h1': {
      margin: 0,
      fontSize: 20,
      color: '#386093',
      fontWeight: 600
    }
  },
  header: {
    backgroundColor: '#ADB8CC33',
    height: '20%',
    padding: '32px 0px 0px 32px',
    overflow: 'auto',
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%',
      height: '8px',
      backgroundColor: 'white'
    }
  },
  description: {
    fontSize: 14,
    width: '60%'
  },
  main: {
    padding: '32px 0px 0px 32px',
    height: '80%',
    overflow: 'auto'
  },
  label_wrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    width: '100%',
    '& p': {
      color: '#386093',
      fontWeight: 600,
      margin: 0,
      fontSize: 18
    }
  },
  last_message_date: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    width: 140,
    height: 25
  },
  last_message_wrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },
  tableRootClass: {
    '& .MuiTable-root': {
      borderCollapse: 'unset !important',
      borderSpacing: '0px 8px !important'
    }
  },
  pending_messages: {
    width: 35,
    height: 35,
    borderRadius: 16,
    backgroundColor: '#EF7C8F',
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& p': {
      margin: 0
    }
  }
}))

const ModerationMessages = ({
  moderationOption,
  getRooms,
  roomsReducer,
  history,
  setModerationOption
}) => {
  const classes = useStyles()
  const sagasParams = {
    withoutRoomTypeFilter: true,
    withoutFractalIdFilter: true
  }

  React.useEffect(() => {
    if (moderationOption.paramsToGetRooms) {
      getRooms({
        ...sagasParams,
        params: {
          ...moderationOption.paramsToGetRooms
        }
      })
    }
  }, [])

  const handleClickRoom = roomId => {
    setModerationOption(prev => ({ ...prev, selected: false }))
    history.push(`/rooms/${roomId}`)
  }

  return (
    <div className={classes.root}>
      <header className={classes.header}>
        <div className={classes.page_title}>
          <StyledSVG src={warningSVG} height={20} width={20} />
          <h1>Moderação de mensagens</h1>
        </div>
        <p className={classes.description}>
          Revise e gerencie as mensagens enviadas por professores antes que
          cheguem aos destinatários. Você pode aprovar, editar ou recusar com
          justificativa, cuidando da qualidade da comunicação escolar.
        </p>
      </header>
      <main className={classes.main}>
        <div className={classes.label_wrapper}>
          <p>Mensagens</p>
        </div>
        <CustomTable
          from={'rooms'}
          rowColor={'#ADB8CC33'}
          classRoot={classes.tableRootClass}
          columns={[
            {
              key: 'room_participants',
              name: 'Participantes',
              width: '30%',
              render: function render (row) {
                return (
                  <div onClick={() => handleClickRoom(row.id)}>
                    <AvatarGroup max={4} spacing={1}>
                      {row.room_participants?.length > 0 &&
                        row.room_participants.map((rp, idx) => {
                          const index =
                            numberFromText(rp?.user.name?.slice(0, 2)) %
                            colors.length
                          return (
                            <Tooltip
                              key={`user[${idx}]`}
                              title={rp?.user?.name}
                              arial-label='usuario'
                            >
                              <Avatar
                                style={{
                                  height: '30px',
                                  width: '30px',
                                  backgroundColor:
                                    // eslint-disable-next-line standard/computed-property-even-spacing
                                    colors[index]
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: '14px',
                                    fontWeight: 400,
                                    lineHeight: '17px',
                                    letterSpacing: '0em',
                                    textAlign: 'left'
                                  }}
                                >
                                  {rp?.user?.name[0]}
                                </p>
                              </Avatar>
                            </Tooltip>
                          )
                        })}
                    </AvatarGroup>
                  </div>
                )
              }
            },
            {
              key: 'last_message',
              name: 'Último envio',
              width: '30%',
              render: function render (row) {
                const index =
                  numberFromText(row.last_message_author?.slice(0, 2)) %
                  colors.length
                return (
                  <div
                    onClick={() => handleClickRoom(row.id)}
                    className={classes.last_message_wrapper}
                  >
                    <Tooltip
                      title={row?.last_message_author}
                      arial-label='usuario'
                    >
                      <Avatar
                        style={{
                          height: '30px',
                          width: '30px',
                          backgroundColor:
                            // eslint-disable-next-line standard/computed-property-even-spacing
                            colors[index]
                        }}
                      >
                        <p
                          style={{
                            fontSize: '14px',
                            fontWeight: 400,
                            lineHeight: '17px',
                            letterSpacing: '0em',
                            textAlign: 'left'
                          }}
                        >
                          {row.last_message_author?.[0]}
                        </p>
                      </Avatar>
                    </Tooltip>
                    <div className={classes.last_message_date}>
                      {moment(row?.last_message?.created_at).format(
                        'DD/MM/YYYY HH:mm'
                      )}
                    </div>
                  </div>
                )
              }
            },
            {
              key: 'pengind_messages',
              name: 'Mensagens pendentes',
              render: function render (row) {
                return (
                  <div
                    onClick={() => handleClickRoom(row.id)}
                    className={classes.pending_messages}
                  >
                    <p>{row.pending_messages_moderation_count || 0}</p>
                  </div>
                )
              }
            }
          ]}
          data={roomsReducer.items}
          columnsPointer={[0, 1, 2]}
          border={'none'}
          bodyBorder={'none'}
          headCellRadius
          isFetching={roomsReducer.isFetching}
          fetchItems={getRooms}
          sagasParams={sagasParams}
          params={moderationOption.paramsToGetRooms}
          pagination={roomsReducer.pagination}
        />
      </main>
    </div>
  )
}

export default ModerationMessages
